import zxcvbn from 'zxcvbn';

class PasswordStrength {
    #inputs;

    constructor({inputs}) {
        this.#inputs = inputs;

        this.#handleKeyUp();
    }


    #handleKeyUp() {
        const levels = ['very-weak', 'weak', 'medium', 'strong', 'very-strong'];

        this.#inputs?.forEach(passwordStrengthEl => {
            const passwordInput = document.getElementById(passwordStrengthEl.dataset.relatedInputId);
            let strengthInput = document.getElementById(passwordStrengthEl.dataset.strengthInputId);

            passwordInput?.addEventListener('keyup', e => {
                const form = e.target.closest('form');
                const strength = zxcvbn(e.target.value, form.querySelectorAll('input, select, textarea'));

                levels.forEach(level => passwordStrengthEl.classList.remove(level));
                if ('' !== passwordInput.value) {
                    passwordStrengthEl.classList.add(levels[strength.score]);
                }

                if (!strengthInput) {
                    strengthInput = document.createElement('input');
                    Object.assign(strengthInput, {
                        name: passwordStrengthEl.dataset.strengthInputId,
                        id: passwordStrengthEl.dataset.strengthInputId,
                        type: 'hidden'
                    });
                    form.appendChild(strengthInput);
                }
                strengthInput.value = '';
                if ('' !== passwordInput.value) {
                    strengthInput.value = strength.score;
                }
            });
        });
    }
}

export default PasswordStrength;
